"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdornmentContainerStyled = exports.leftOrRight = exports.getSiteTheme = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = require("styled-components");
exports.getSiteTheme = function (site) {
    var siteTheme = require("./theme/" + site);
    var themeName = site + "Theme";
    return siteTheme.hasOwnProperty(themeName) ? siteTheme[themeName] : '';
};
exports.leftOrRight = function (startOrEnd) {
    switch (startOrEnd) {
        case 'start':
            return 'left';
        case 'end':
            return 'right';
        default:
            return 'right';
    }
};
exports.AdornmentContainerStyled = styled_components_1.default.span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    var theme = exports.getSiteTheme(props.site);
    return theme;
});
var templateObject_1;
//# sourceMappingURL=AdornmentContainer.styled.js.map